import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { ButtonBasic } from '../../components';

const ModalPreviewEmailDebitoRechazado = ({
  show,
  hideModal,
  row,
  template,
 }) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const handleClose = () => hideModal();

    const contrato = row?.contrato || '-';
    const cuenta = row?.cuenta || '-';
    const motivo = row?.motivo || '-';
    const email = row?.email || '-';

    const asunto = template?.asunto_pmail || `Débito automático rechazado - Servicio ${contrato}`;
    const cuerpoHtml = template?.cuerpo_pmail
        ? template.cuerpo_pmail.replaceAll('{{MOTIVO_RECHAZO}}', `<strong>${motivo}</strong>`)
        : null;

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth>
            <Box sx={{ background: isDarkMode ? '#1F2A40' : '#fff' }}>
                <DialogTitleDefault id='preview-email-debito' onClose={handleClose}>
                    <Stack direction='row' alignItems='center' spacing={1} sx={{ flex: 1 }}>
                        <EmailIcon sx={{ color: '#1976d2' }} />
                        <Typography sx={{ color: isDarkMode ? '#fff' : '#000', fontWeight: 'bold' }} variant='h6'>
                            Vista previa del Email
                        </Typography>
                    </Stack>
                </DialogTitleDefault>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogContent sx={{ background: isDarkMode ? '#0f1626' : '#eef2f7', py: 3 }}>
                    <Box
                        sx={{
                            maxWidth: 640,
                            mx: 'auto',
                            background: '#ffffff',
                            borderRadius: 2,
                            overflow: 'hidden',
                            boxShadow: '0 4px 18px rgba(0,0,0,0.15)',
                        }}
                    >
                        <Box sx={{ background: '#0d47a1', color: '#fff', px: 3, py: 2 }}>
                            <Typography sx={{ fontSize: 12, opacity: 0.85 }}>Nubicom - Atención al Cliente</Typography>
                            <Typography sx={{ fontSize: 18, fontWeight: 'bold' }}>{asunto}</Typography>
                        </Box>

                        <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #eee', background: '#fafafa' }}>
                            <Stack direction='row' spacing={2} sx={{ fontSize: 12, color: '#555' }}>
                                <Box><b>Para:</b> {email}</Box>
                                <Box><b>Cuenta:</b> {cuenta}</Box>
                                <Box><b>Contrato:</b> {contrato}</Box>
                            </Stack>
                        </Box>

                        <Box sx={{ px: 3, py: 3, color: '#222', fontSize: 14 }}>
                            {cuerpoHtml ? (
                                <div dangerouslySetInnerHTML={{ __html: cuerpoHtml }} />
                            ) : (
                                <Typography sx={{ color: '#999', fontStyle: 'italic' }}>Sin template disponible.</Typography>
                            )}
                        </Box>

                        <Box sx={{ background: '#f5f5f5', px: 3, py: 1.5, fontSize: 11, color: '#777', textAlign: 'center' }}>
                            Este es un correo de vista previa generado para revisión interna.
                        </Box>
                    </Box>
                </DialogContent>
                <Divider sx={{ background: isDarkMode ? '#3d4a62' : 'gray' }} />
                <DialogActions sx={{ p: 2 }}>
                    <ButtonBasic textButton='Cerrar' variant='outlined' color='inherit' onClick={handleClose} />
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default ModalPreviewEmailDebitoRechazado;
